import { sniff, eventBus } from '@/util'

// 抹平三端登录，回掉函数中返回的数据如下
// token 登录态
// isLogin 是否登录
const userAppLogin = function (callback) {
  eventBus.addListener('USERLOGIN', userData => {
    callback && callback(userData)
  })
  if (sniff.isUboxAndroidApp) {
    window.app.userLogin && window.app?.userLogin()
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.userLogin && window?.webkit?.messageHandlers?.userLogin.postMessage('')
  }
}

export default userAppLogin